export enum RemindCategoryType {
  ALL = '',
  BIRTHDAY = 'birthday',
  HONEY_MOON = 'honey_moon',
  ANNIVERSARY = 'anniversary',
  EXTRA_BED = 'extra_bed',
  DROP_OFF = 'drop_off',
  PICK_UP = 'pick_up',
  PAYMENT = 'payment',
  OTHER = 'other'
}

export const REMIND_CATEGORIES_OPTIONS: {
  label: string;
  value: RemindCategoryType;
}[] = [
  { label: 'common.categoties.birthday', value: RemindCategoryType.BIRTHDAY },
  { label: 'common.categoties.honeyMoon', value: RemindCategoryType.HONEY_MOON },
  { label: 'common.categoties.anniversary', value: RemindCategoryType.ANNIVERSARY },
  { label: 'common.categoties.extraBed', value: RemindCategoryType.EXTRA_BED },
  { label: 'common.categoties.dropOff', value: RemindCategoryType.DROP_OFF },
  { label: 'common.categoties.pickUp', value: RemindCategoryType.PICK_UP },
  { label: 'common.categoties.payment', value: RemindCategoryType.PAYMENT },
  { label: 'common.categoties.other', value: RemindCategoryType.OTHER }
];

// Options for filtering (includes ALL option)
export const REMIND_CATEGORIES_FILTER_OPTIONS: {
  label: string;
  value: RemindCategoryType;
}[] = [
  { label: 'common.statuses.all', value: RemindCategoryType.ALL },
  { label: 'common.categoties.birthday', value: RemindCategoryType.BIRTHDAY },
  { label: 'common.categoties.honeyMoon', value: RemindCategoryType.HONEY_MOON },
  { label: 'common.categoties.anniversary', value: RemindCategoryType.ANNIVERSARY },
  { label: 'common.categoties.extraBed', value: RemindCategoryType.EXTRA_BED },
  { label: 'common.categoties.dropOff', value: RemindCategoryType.DROP_OFF },
  { label: 'common.categoties.pickUp', value: RemindCategoryType.PICK_UP },
  { label: 'common.categoties.payment', value: RemindCategoryType.PAYMENT },
  { label: 'common.categoties.other', value: RemindCategoryType.OTHER }
];
